// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"PackageTile_imageWrap__1ZTKZ","image":"PackageTile_image__1ge0g","imageStub":"PackageTile_imageStub__2h2O2"};